import _ from 'lodash';
import React, { Component } from 'react';

import {
  DragDropContext,
  Droppable,
  Draggable,
} from 'react-beautiful-dnd';

import {
  getImperativesStages
} from '../../../util/data';

class CustomDealStageMappingEditor extends Component{

  state = {

  }

  dealStages(){
    return _.filter((this.props.organization || {}).dealStages, stage => {
      return stage.status === 'open';
    });
  }
  dealStageObjectivesToMap(){
    return getImperativesStages().objectives;
  }
  dealStageReciprocationsToMap(){
    return getImperativesStages().reciprocations;
  }

  stageMappingDoesNotExist(mappedValue){
    return _.map(this.dealStages(), 'value').indexOf(mappedValue) === -1;
  }

  itemsForStage(stageId){
    const { customDealStageMapping } = this.props.organization || {};

    if(!customDealStageMapping){
      return [];
    }

    const itemsForStage = [];

    _.each(this.dealStageObjectivesToMap(), objective => {
      if(customDealStageMapping[objective.id] === stageId){
        itemsForStage.push(objective);
      }
      else if(stageId === undefined && this.stageMappingDoesNotExist(customDealStageMapping[objective.id])){
        itemsForStage.push(objective);
      }
    });
    _.each(this.dealStageReciprocationsToMap(), reciprocation => {
      if(customDealStageMapping[reciprocation.id] === stageId){
        itemsForStage.push(reciprocation);
      }
      else if(stageId === undefined && this.stageMappingDoesNotExist(customDealStageMapping[reciprocation.id])){
        itemsForStage.push(reciprocation);
      }
    });

    return itemsForStage;
  }

  renderStageItem(item, index){
    return (
      <Draggable draggableId={item.id} key={`stage-item-${item.id}`} index={index}>
        {(provided, snapshot) => (
          <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} className="stage-item">{item.text}</div>
        )}
      </Draggable>
    )
  };

  renderDealStageCustomMappings(stage){
    return (
      <Droppable droppableId={stage.value || 'unassigned'} key={`mappings-for-stage-${stage.value}`}>
        {(provided, snapshot) => (
          <div ref={provided.innerRef} {...provided.droppableProps} className={`mappings-for-stage ${!stage.value ? 'unassigned' : ''}`}>
            <h6>{stage.label}</h6>
            <ul className="stage-items">
              {_.map(this.itemsForStage(stage.value), this.renderStageItem.bind(this))}
            </ul>
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    );
  }

  onDragEnd(dropResult){
    const {
      draggableId,
      source,
      destination,
      type
    } = dropResult;

    if(draggableId && source && destination && source.droppableId !== destination.droppableId && destination.droppableId !== 'unassigned'){
      console.log(`dragging from ${source.droppableId} to ${destination.droppableId}`);
      this.props.updateDealStageMapping({
        ...this.props.organization.customDealStageMapping,
        [draggableId]: (destination.droppableId && destination.droppableId !== 'undefined') ? destination.droppableId : null
      });
    }
  }

  render(){

    return(
      <div className="deal-stage-mapping-editor">
        <DragDropContext
          onDragEnd={this.onDragEnd.bind(this)}
        >
        {this.renderDealStageCustomMappings({label: 'Unassigned'})}
        {_.map(this.dealStages(), this.renderDealStageCustomMappings.bind(this))}
        </DragDropContext>
      </div>
    )
  }
}

export default CustomDealStageMappingEditor;



// WEBPACK FOOTER //
// ./src/components/settings/sections/customDealStageMappingEditor.js